(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('about-page-panel')) {
    customElements.define(
      'about-page-panel',
      class AboutPagePanel extends HTMLElement {
        connectedCallback() {
          this.copy = this.querySelector('.about-page__copy');
          this.wideLayoutQuery = window.matchMedia('(min-width: 46.9375rem)');
          this.measure = this.measure.bind(this);

          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this);
          if (this.copy) this.resizeObserver.observe(this.copy);
          this.wideLayoutQuery.addEventListener('change', this.measure);
          this.measure();
          this.prepareReveal();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.revealObserver?.disconnect();
          this.wideLayoutQuery?.removeEventListener('change', this.measure);
          cancelAnimationFrame(this.measurementFrame);
        }

        prepareReveal() {
          if (!this.classList.contains('about-page__panel--philosophy')) return;

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reducedMotion || !('IntersectionObserver' in window)) {
            this.classList.add('is-about-reveal-visible');
            return;
          }

          this.classList.add('is-about-reveal-ready');
          this.revealObserver = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;

            this.classList.add('is-about-reveal-visible');
            this.revealObserver.disconnect();
          }, {
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.01,
          });
          this.revealObserver.observe(this);
        }

        measure() {
          cancelAnimationFrame(this.measurementFrame);
          this.measurementFrame = requestAnimationFrame(() => {
            if (!this.copy || !this.wideLayoutQuery.matches) {
              this.classList.remove('about-page__panel--copy-wide');
              return;
            }

            this.classList.remove('about-page__panel--copy-wide');
            const contentExceedsGridArea = this.copy.scrollHeight > this.copy.clientHeight + 1;
            this.classList.toggle('about-page__panel--copy-wide', contentExceedsGridArea);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const cartPage = document.querySelector('[data-cart-page]');
    if (!cartPage || cartPage.dataset.enhanced === 'true') return;
    cartPage.dataset.enhanced = 'true';

    const related = cartPage.querySelector('[data-cart-recommendations]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileQuery = window.matchMedia('(max-width: 46.875rem)');
    let rowObserver;

    if ('IntersectionObserver' in window) {
      rowObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const grid = entry.target.closest('.cart-related__grid');
          const rowTop = entry.target.offsetTop;

          grid?.querySelectorAll('.product-card.is-later-product-row').forEach((card) => {
            if (Math.abs(card.offsetTop - rowTop) > 1) return;

            card.classList.add('is-row-visible');
            rowObserver.unobserve(card);
          });
        });
      }, {
        rootMargin: '0px 0px -2% 0px',
        threshold: 0.01,
      });
    }

    const prepareRelatedRows = (recommendations) => {
      if (reducedMotion || !mobileQuery.matches || !rowObserver) return;

      const grid = recommendations?.querySelector('.cart-related__grid');
      const cards = Array.from(grid?.querySelectorAll('.product-card') || []);
      const firstRowTop = cards[0]?.offsetTop;

      if (!grid || firstRowTop === undefined) return;

      cards.forEach((card) => {
        rowObserver.unobserve(card);
        card.classList.remove('is-later-product-row', 'is-row-visible');

        if (Math.abs(card.offsetTop - firstRowTop) <= 1) return;

        card.classList.add('is-later-product-row');
        rowObserver.observe(card);
      });

      grid.classList.add('is-row-reveal-ready');
    };

    if (related) {
      if (reducedMotion || !('IntersectionObserver' in window)) {
        related.classList.add('is-cart-related-reveal-visible');
      } else {
        related.classList.add('is-cart-related-reveal-ready');
        const revealObserver = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;

          related.classList.add('is-cart-related-reveal-visible');
          revealObserver.disconnect();
        }, {
          rootMargin: '0px 0px -10% 0px',
          threshold: 0.01,
        });
        revealObserver.observe(related);
      }

      prepareRelatedRows(related);
    }

    const enhanceRecommendations = async () => {
      const recommendations = cartPage.querySelector('[data-cart-recommendations]');
      const grid = recommendations?.querySelector('[data-cart-recommendations-grid]');
      const requests = recommendations?.querySelectorAll('[data-cart-recommendation-url]');
      if (!grid || !requests?.length) return;

      const cartProductIds = new Set(
        [...cartPage.querySelectorAll('[data-cart-product-id]')].map((item) => item.dataset.cartProductId),
      );
      const fallbackCards = [...grid.querySelectorAll('[data-product-id]')];
      const candidates = new Map();
      let order = 0;

      await Promise.all(
        [...requests].map(async (request) => {
          try {
            const response = await fetch(request.dataset.cartRecommendationUrl);
            if (!response.ok) return;
            const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');

            documentFragment.querySelectorAll('[data-cart-complementary-response] [data-product-id]').forEach((card) => {
              const productId = card.dataset.productId;
              if (!productId || cartProductIds.has(productId)) return;

              const existing = candidates.get(productId);
              if (existing) {
                existing.score += 1;
                return;
              }

              candidates.set(productId, { card, score: 1, order: order++ });
            });
          } catch (_error) {
            // The Liquid fallback remains visible when recommendations cannot load.
          }
        }),
      );

      if (!candidates.size) return;

      const selectedCards = [...candidates.values()]
        .sort((first, second) => second.score - first.score || first.order - second.order)
        .map((candidate) => candidate.card);
      const selectedIds = new Set(selectedCards.map((card) => card.dataset.productId));

      fallbackCards.forEach((card) => {
        if (selectedCards.length >= 4) return;
        if (selectedIds.has(card.dataset.productId)) return;
        selectedCards.push(card);
        selectedIds.add(card.dataset.productId);
      });

      grid.querySelectorAll('.product-card').forEach((card) => rowObserver?.unobserve(card));
      grid.replaceChildren(...selectedCards.slice(0, 4));
      prepareRelatedRows(recommendations);
    };

    enhanceRecommendations();

    const form = cartPage.querySelector('[data-cart-form]');
    if (!form) return;

    const updateQuantity = async (control, input, nextQuantity) => {
      const previousQuantity = Number(input.dataset.cartCurrentQuantity) || 0;
      const buttons = control.querySelectorAll('[data-cart-quantity-change]');
      const message = control.querySelector('[data-cart-message]');

      input.value = nextQuantity;
      buttons.forEach((button) => { button.disabled = true; });
      message.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: control.dataset.cartLineKey,
            quantity: nextQuantity,
          }),
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message);
        }

        window.location.reload();
      } catch (error) {
        input.value = previousQuantity;
        message.textContent = error.message;
        buttons.forEach((button) => { button.disabled = false; });
        const minus = control.querySelector('[data-cart-quantity-change="-1"]');
        if (minus) minus.disabled = previousQuantity <= 1;
      }
    };

    const removeItem = async (removeLink) => {
      if (removeLink.getAttribute('aria-disabled') === 'true') return;

      const control = removeLink.closest('[data-cart-quantity]');
      const buttons = control?.querySelectorAll('[data-cart-quantity-change]');
      const message = control?.querySelector('[data-cart-message]');
      if (!control || !buttons || !message) return;

      control.classList.add('is-removing');
      removeLink.setAttribute('aria-disabled', 'true');
      buttons.forEach((button) => { button.disabled = true; });
      message.textContent = '';

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: control.dataset.cartLineKey,
            quantity: 0,
          }),
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message);
        }

        window.location.reload();
      } catch (error) {
        control.classList.remove('is-removing');
        removeLink.removeAttribute('aria-disabled');
        message.textContent = error.message;
        buttons.forEach((button) => { button.disabled = false; });

        const input = control.querySelector('[data-cart-quantity-input]');
        const minus = control.querySelector('[data-cart-quantity-change="-1"]');
        if (minus) minus.disabled = (Number(input?.value) || 0) <= 1;
      }
    };

    cartPage.addEventListener('click', (event) => {
      const removeLink = event.target.closest('.cart-item__remove');
      if (removeLink) {
        event.preventDefault();
        removeItem(removeLink);
        return;
      }

      const button = event.target.closest('[data-cart-quantity-change]');
      if (!button || button.disabled) return;

      const control = button.closest('[data-cart-quantity]');
      const input = control?.querySelector('[data-cart-quantity-input]');
      if (!input) return;

      const nextQuantity = Math.max(0, (Number(input.value) || 0) + Number(button.dataset.cartQuantityChange));
      updateQuantity(control, input, nextQuantity);
    });

    cartPage.addEventListener('change', (event) => {
      if (!event.target.matches('[data-cart-quantity-input]')) return;
      const input = event.target;
      const control = input.closest('[data-cart-quantity]');
      if (!control) return;
      updateQuantity(control, input, Math.max(0, Number(input.value) || 0));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileCollectionQuery = window.matchMedia('(max-width: 46.875rem)');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

    const rowObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const grid = entry.target.closest('.collection-catalog__grid');
          const rowTop = entry.target.offsetTop;

          grid?.querySelectorAll('.product-card').forEach((card) => {
            if (Math.abs(card.offsetTop - rowTop) > 1) return;

            card.classList.add('is-row-visible');
            rowObserver.unobserve(card);
          });
        });
      },
      {
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.01,
      },
    );

    const prepareGrids = (root = document) => {
      root.querySelectorAll('.collection-catalog__grid:not(.is-row-reveal-ready)').forEach((grid) => {
        const firstCard = grid.querySelector('.product-card');
        const productCards = Array.from(grid.querySelectorAll('.product-card'));
        const productRowTops = [...new Set(productCards.map((card) => card.offsetTop))].sort((a, b) => a - b);
        const secondRowTop = productRowTops[1];

        if (secondRowTop !== undefined) {
          productCards.forEach((card) => {
            if (Math.abs(card.offsetTop - secondRowTop) <= 1) card.classList.add('is-second-product-row');
          });
        }

        if (firstCard && firstCard.getBoundingClientRect().top < window.innerHeight * 0.9) {
          const firstRowTop = firstCard.offsetTop;

          grid.classList.add('has-entrance-sequence');
          grid.querySelectorAll('.product-card').forEach((card) => {
            if (Math.abs(card.offsetTop - firstRowTop) <= 1) card.classList.add('is-first-product-row');
          });
        }

        grid.classList.add('is-row-reveal-ready', 'is-row-reveal-preparing');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            grid.classList.remove('is-row-reveal-preparing');
            productCards.forEach((card) => {
              if (mobileCollectionQuery.matches && card.classList.contains('is-second-product-row')) {
                return;
              }

              rowObserver.observe(card);
            });

            if (mobileCollectionQuery.matches) {
              requestAnimationFrame(() => {
                productCards.forEach((card) => {
                  if (card.classList.contains('is-second-product-row')) card.classList.add('is-row-visible');
                });
              });
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => prepareGrids(), { once: true });
    } else {
      prepareGrids();
    }

    document.addEventListener('shopify:section:load', (event) => {
      prepareGrids(event.target.parentElement || document);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const initializeCopyEmailControls = (root) => {
    root.querySelectorAll('.site-footer__copy-email').forEach((button) => {
      if (button.dataset.copyInitialized === 'true') return;

      button.addEventListener('click', async () => {
        const value = button.dataset.copyValue;
        const status = button.closest('.site-footer__secondary')?.querySelector('[data-copy-status]');

        try {
          await navigator.clipboard.writeText(value);
        } catch {
          const copyField = document.createElement('textarea');
          copyField.value = value;
          copyField.setAttribute('readonly', '');
          copyField.style.position = 'fixed';
          copyField.style.opacity = '0';
          document.body.appendChild(copyField);
          copyField.select();
          document.execCommand('copy');
          copyField.remove();
        }

        const originalText = button.dataset.originalText || button.textContent.trim();
        button.dataset.originalText = originalText;
        button.textContent = button.dataset.copySuccess;
        button.disabled = true;

        if (button.copyResetTimer) window.clearTimeout(button.copyResetTimer);
        button.copyResetTimer = window.setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
          button.copyResetTimer = null;
        }, 2000);

        if (status) status.textContent = button.dataset.copySuccess;
      });

      button.dataset.copyInitialized = 'true';
    });
  };

  const initializeNewsletterForms = (root) => {
    root.querySelectorAll('.site-footer__form').forEach((form) => {
      if (form.dataset.newsletterInitialized === 'true') return;

      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');

      if (!emailInput || !submitButton) return;

      const updateSubmitState = () => {
        submitButton.disabled = emailInput.value.length === 0;
      };

      emailInput.addEventListener('input', updateSubmitState);
      updateSubmitState();
      form.dataset.newsletterInitialized = 'true';
    });
  };

  initializeCopyEmailControls(document);
  initializeNewsletterForms(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeCopyEmailControls(event.target);
    initializeNewsletterForms(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.site-header:not([data-scroll-header-ready])').forEach((header) => {
    header.dataset.scrollHeaderReady = 'true';

    const scrollThreshold = Number.parseFloat(getComputedStyle(document.documentElement).fontSize) * 1.5;
    const homeHero = document.querySelector('.home-hero');
    let previousScrollPosition = Math.max(window.scrollY, 0);
    let scrollFrame;

    const menuIsOpen = () => Boolean(header.querySelector('.site-header__menu[open]'));

    const updateHeader = () => {
      scrollFrame = undefined;

      const scrollPosition = Math.max(window.scrollY, 0);
      const scrollDistance = scrollPosition - previousScrollPosition;
      const isPastHeader = scrollPosition > header.offsetHeight;
      const isOverHomeHero = homeHero && homeHero.getBoundingClientRect().bottom > header.offsetHeight;

      header.classList.toggle('is-scrolled', isPastHeader && !isOverHomeHero);

      if (scrollPosition <= 0 || menuIsOpen() || header.contains(document.activeElement)) {
        header.classList.remove('is-scroll-hidden');
        previousScrollPosition = scrollPosition;
      } else if (scrollDistance > scrollThreshold && isPastHeader) {
        header.classList.add('is-scroll-hidden');
        previousScrollPosition = scrollPosition;
      } else if (scrollDistance < -scrollThreshold) {
        header.classList.remove('is-scroll-hidden');
        previousScrollPosition = scrollPosition;
      }
    };

    const scheduleHeaderUpdate = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(updateHeader);
    };

    header.addEventListener('focusin', () => header.classList.remove('is-scroll-hidden'));
    window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
    updateHeader();
  });

  document.querySelectorAll('.site-header__menu').forEach((menu) => {
    const summary = menu.querySelector('summary');
    const panel = menu.querySelector('.site-header__menu-panel');
    let closeTimer;
    let returnFocusAfterClose = false;

    const timeToMilliseconds = (value) => {
      const time = Number.parseFloat(value);
      return value.trim().endsWith('ms') ? time : time * 1000;
    };

    const getTransitionTimeout = () => {
      if (!panel) return 0;

      const styles = window.getComputedStyle(panel);
      const durations = styles.transitionDuration.split(',').map(timeToMilliseconds);
      const delays = styles.transitionDelay.split(',').map(timeToMilliseconds);
      const transitionCount = Math.max(durations.length, delays.length);
      let longestTransition = 0;

      for (let index = 0; index < transitionCount; index += 1) {
        const duration = durations[index % durations.length];
        const delay = delays[index % delays.length];
        longestTransition = Math.max(longestTransition, duration + delay);
      }

      return longestTransition + 100;
    };

    const finishClose = () => {
      if (!menu.classList.contains('is-closing')) return;

      window.clearTimeout(closeTimer);
      menu.classList.remove('is-closing');
      menu.removeAttribute('open');

      if (returnFocusAfterClose) summary?.focus();
      returnFocusAfterClose = false;
    };

    const closeMenu = (returnFocus = false) => {
      if (!menu.open || menu.classList.contains('is-closing')) return;

      returnFocusAfterClose = returnFocus;
      menu.classList.add('is-closing');
      menu.classList.add('suppress-toggle-hover');
      menu.classList.remove('is-animated-open');
      closeTimer = window.setTimeout(finishClose, getTransitionTimeout());
    };

    menu.classList.add('is-slide-enhanced');

    menu.addEventListener('toggle', () => {
      if (menu.open) {
        menu.classList.add('suppress-toggle-hover');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => menu.classList.add('is-animated-open'));
        });
      } else {
        menu.classList.remove('is-animated-open');
      }
    });

    summary?.addEventListener('pointerleave', () => {
      menu.classList.remove('suppress-toggle-hover');
    });

    summary?.addEventListener('click', (event) => {
      if (menu.open) {
        event.preventDefault();
        closeMenu();
      }
    });

    panel?.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'transform') finishClose();
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu(true);
      }
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const detail = section.querySelector('.product-main__detail');
    const productImage = section.querySelector('.product-main__image:not(.product-main__image--placeholder)');
    const startEntrance = () => detail?.classList.add('is-product-entrance-ready');
    const markImageReady = () => {
      detail?.classList.add('is-product-media-ready');
    };

    window.setTimeout(startEntrance, 160);

    if (!productImage || productImage.complete) {
      if (productImage?.decode) {
        productImage.decode().catch(() => {}).finally(markImageReady);
      } else {
        markImageReady();
      }
    } else {
      productImage.addEventListener('load', () => {
        if (productImage.decode) {
          productImage.decode().catch(() => {}).finally(markImageReady);
        } else {
          markImageReady();
        }
      }, { once: true });
      productImage.addEventListener('error', markImageReady, { once: true });
    }

    const form = section.querySelector('[data-product-form]');
    const submit = form?.querySelector('[data-product-submit]');
    const label = form?.querySelector('[data-product-submit-label]');
    const message = form?.querySelector('[data-product-message]');
    if (!form || !submit || !label || !message || form.dataset.enhanced === 'true') return;

    form.dataset.enhanced = 'true';
    const drawerDetails = form.querySelector('[data-product-drawer-details]');
    const productSize = drawerDetails?.dataset.productSize || '';
    const productPrice = drawerDetails?.dataset.productPrice || '';
    const getCart = async () => {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    };

    const getVariantQuantity = (cart, variantId) => cart.items
      .filter((item) => Number(item.variant_id) === variantId)
      .reduce((quantity, item) => quantity + item.quantity, 0);

    const showErrorMessage = (text) => {
      const cartPhrase = /your cart/i;
      const match = text.match(cartPhrase);
      if (!match) {
        message.textContent = text;
        return;
      }

      const matchIndex = match.index;
      const cartLink = document.createElement('a');
      cartLink.href = message.dataset.cartUrl;
      cartLink.textContent = match[0];
      message.replaceChildren(
        document.createTextNode(text.slice(0, matchIndex)),
        cartLink,
        document.createTextNode(text.slice(matchIndex + match[0].length)),
      );
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      submit.disabled = true;
      submit.dataset.state = 'loading';
      submit.setAttribute('aria-busy', 'true');
      label.textContent = submit.dataset.loadingLabel;
      message.textContent = '';

      try {
        const formData = new FormData(form);
        const requestedQuantity = Number(formData.get('quantity')) || 1;
        const variantId = Number(formData.get('id'));
        const cartBefore = await getCart();
        const quantityBefore = getVariantQuantity(cartBefore, variantId);
        const response = await fetch(`${form.action}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok) {
          const cartAfter = await getCart();
          const addedQuantity = Math.max(0, getVariantQuantity(cartAfter, variantId) - quantityBefore);
          const addedItem = cartAfter.items.find((item) => Number(item.variant_id) === variantId);

          if (addedQuantity > 0 && addedItem) {
            submit.dataset.state = 'purchased';
            submit.removeAttribute('aria-busy');
            label.textContent = submit.dataset.successLabel;
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                item: addedItem,
                addedQuantity,
                partialAdd: true,
                productSize,
                productPrice,
              },
            }));

            window.setTimeout(() => {
              submit.dataset.state = 'default';
              label.textContent = submit.dataset.defaultLabel;
              submit.disabled = false;
            }, 1000);
            return;
          }

          throw new Error(result.description || result.message);
        }

        submit.dataset.state = 'purchased';
        submit.removeAttribute('aria-busy');
        label.textContent = submit.dataset.successLabel;
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            item: result,
            addedQuantity: requestedQuantity,
            productSize,
            productPrice,
          },
        }));
        window.setTimeout(() => {
          submit.dataset.state = 'default';
          label.textContent = submit.dataset.defaultLabel;
          submit.disabled = false;
        }, 1000);
      } catch (error) {
        submit.dataset.state = 'default';
        submit.removeAttribute('aria-busy');
        label.textContent = submit.dataset.defaultLabel;
        submit.disabled = false;
        showErrorMessage(error.message || message.dataset.errorLabel);
      }
    });
  });

  document.querySelectorAll('[data-product-disclosure]').forEach((disclosure) => {
    const summary = disclosure.querySelector('summary');
    const content = disclosure.querySelector('[data-product-disclosure-content]');
    if (!summary || !content || disclosure.dataset.enhanced === 'true') return;

    disclosure.dataset.enhanced = 'true';
    let animation;

    summary.addEventListener('click', (event) => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !content.animate) return;

      event.preventDefault();
      animation?.cancel();

      if (!disclosure.open) {
        disclosure.removeAttribute('data-closing');
        disclosure.open = true;
        animation = content.animate(
          [
            { height: '0', opacity: 0 },
            { height: `${content.scrollHeight}px`, opacity: 1 },
          ],
          { duration: 300, easing: 'ease-out' }
        );
      } else {
        disclosure.setAttribute('data-closing', '');
        animation = content.animate(
          [
            { height: `${content.offsetHeight}px`, opacity: 1 },
            { height: '0', opacity: 0 },
          ],
          { duration: 300, easing: 'ease-out' }
        );
        animation.addEventListener('finish', () => {
          disclosure.open = false;
          disclosure.removeAttribute('data-closing');
        }, { once: true });
      }

      content.style.overflow = 'hidden';
      animation.addEventListener('finish', () => {
        content.style.removeProperty('overflow');
        animation = undefined;
      }, { once: true });
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((recommendations) => {
    if (recommendations.dataset.enhanced === 'true') return;
    recommendations.dataset.enhanced = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileQuery = window.matchMedia('(max-width: 46.875rem)');
    let rowObserver;

    if ('IntersectionObserver' in window) {
      rowObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const grid = entry.target.closest('.product-related__grid');
          const rowTop = entry.target.offsetTop;

          grid?.querySelectorAll('.product-card.is-later-product-row').forEach((card) => {
            if (Math.abs(card.offsetTop - rowTop) > 1) return;

            card.classList.add('is-row-visible');
            rowObserver.unobserve(card);
          });
        });
      }, {
        rootMargin: '0px 0px -2% 0px',
        threshold: 0.01,
      });
    }

    const prepareRelatedRows = (result) => {
      if (reducedMotion || !mobileQuery.matches || !rowObserver) return;

      const grid = result.querySelector('.product-related__grid');
      const cards = Array.from(grid?.querySelectorAll('.product-card') || []);
      const firstRowTop = cards[0]?.offsetTop;

      if (!grid || firstRowTop === undefined) return;

      cards.forEach((card) => {
        if (Math.abs(card.offsetTop - firstRowTop) <= 1) return;

        card.classList.add('is-later-product-row');
        rowObserver.observe(card);
      });

      grid.classList.add('is-row-reveal-ready');
    };

    const prepareRelatedReveal = (result) => {
      if (reducedMotion || !('IntersectionObserver' in window)) {
        result.classList.add('is-product-related-visible');
        return;
      }

      result.classList.add('is-product-related-reveal-ready');
      const revealObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        result.classList.add('is-product-related-visible');
        revealObserver.disconnect();
      }, {
        rootMargin: mobileQuery.matches ? '0px 0px -5% 0px' : '0px 0px -10% 0px',
        threshold: 0.01,
      });
      revealObserver.observe(result);
    };

    const loadRecommendations = async () => {
      try {
        const response = await fetch(recommendations.dataset.url);
        if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const result = documentFragment.querySelector('[data-product-recommendations-result]');

        if (result) {
          recommendations.replaceChildren(result);
          prepareRelatedReveal(result);
          prepareRelatedRows(result);
        } else {
          recommendations.remove();
        }
      } catch (error) {
        recommendations.remove();
        console.error(error);
      }
    };

    if (!('IntersectionObserver' in window)) {
      loadRecommendations();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadRecommendations();
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(recommendations);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('visit-page-layout')) {
    customElements.define(
      'visit-page-layout',
      class VisitPageLayout extends HTMLElement {
        connectedCallback() {
          this.information = this.querySelector('.visit-page__information');
          this.wideLayoutQuery = window.matchMedia('(min-width: 46.9375rem)');
          this.measure = this.measure.bind(this);

          this.resizeObserver = new ResizeObserver(this.measure);
          this.resizeObserver.observe(this);
          this.wideLayoutQuery.addEventListener('change', this.measure);
          this.measure();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.wideLayoutQuery?.removeEventListener('change', this.measure);
          cancelAnimationFrame(this.measurementFrame);
        }

        measure() {
          cancelAnimationFrame(this.measurementFrame);
          this.measurementFrame = requestAnimationFrame(() => {
            if (!this.information || !this.wideLayoutQuery.matches) {
              this.classList.remove('visit-page__layout--information-wide');
              return;
            }

            this.classList.remove('visit-page__layout--information-wide');
            const styles = getComputedStyle(this.information);
            const gap = Number.parseFloat(styles.rowGap) || 0;
            const childrenHeight = [...this.information.children].reduce(
              (total, child) => total + child.getBoundingClientRect().height,
              0
            );
            const contentHeight = childrenHeight + gap * Math.max(this.information.children.length - 1, 0);
            const exceedsSecondRow = contentHeight > this.information.getBoundingClientRect().height + 1;
            this.classList.toggle('visit-page__layout--information-wide', exceedsSecondRow);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
